export const AppSidebarLink = {
  extends: 'Link',
  href: (el) => el.href || '#',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  minHeight: 'controlH',
  padding: 'Z A',
  round: 'radiusPill',
  cursor: 'pointer',
  fontSize: 'Z2',
  textDecoration: 'none',
  isActive: (el, s) =>
    el.call('stripWorkspacePrefix', s.root?.route || s.root?.currentPath || '/') === el.href,
  'aria-current': (el, s) =>
    el.call('stripWorkspacePrefix', s.root?.route || s.root?.currentPath || '/') === el.href
      ? 'page'
      : undefined,
  fontWeight: '500',
  color: 'inactive',
  '.isActive': { background: 'selected', color: 'title', fontWeight: '700' },
  ':hover': {
    background: 'hover',
    color: 'title'
  },
  ':active': { background: 'selected', color: 'title' },
  ':focus-visible': { background: 'selected', color: 'title' },

  Icon: {
    icon: (el) => el.parent.icon || 'state',
    boxSize: 'A',
    color: 'currentColor',
    'aria-hidden': true
  },
  Label: { tag: 'span', text: (el) => el.parent.label || '' },

  onClick: (e, el) => {
    // Keep standard link affordances: modified clicks can open a new tab.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button != null && e.button !== 0))
      return
    e.preventDefault()
    el.router(el.href, el.getRoot())
  }
}
